import type { QueryKey } from '@tanstack/react-query';
import { useTranslation } from 'react-i18next';
import type { AlertSettingKey, IAlertsHubUpdate } from '@d-orca/shared/alert-kinds';
import { useOptimisticSettingUpdate as useSharedSettingUpdate } from '@d-orca/shared/client/hooks';
import { useToast } from '@components/ui/Toasts/toastContext';

/**
 * Saves one alert setting the way both settings pages do (the shared
 * `useOptimisticSettingUpdate`: the row changes at once, a failure puts it
 * back, every write ends in a refetch) — and says a failure with a toast,
 * the web's way.
 */
export function useOptimisticSettingUpdate<U extends IAlertsHubUpdate>(
  queryKey: QueryKey,
  save: (key: AlertSettingKey, update: U) => Promise<unknown>,
) {
  const { t } = useTranslation();
  const push = useToast();
  return useSharedSettingUpdate(queryKey, save, () => push({ kind: 'error', title: t('alertSettings.saveFailed') }));
}
